var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.show,"headline":"Cancel Invite","avatar":{
      firstName: this.account?.owner_first_name,
      lastName: this.account?.owner_last_name
    },"htmlInfo":_vm.info,"actionLabel":"Cancel Invite","destructive":true},on:{"input":function($event){return _vm.$emit('onClose')},"onAction":function($event){return _vm.$emit('onAction')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }